module.exports = __webpack_public_path__ + "img/73.d0a2ecb3.png";